import { Component } from '@angular/core';

/**
 * An empty stop the router passes through, so the album page is destroyed and
 * built again for a different album without a reload.
 *
 * Navigating to the album page from the album page reuses the mounted page and
 * never re-runs its setup. The two other ways round both break something: a
 * reload ends an upload running in this page, and Home's setup deletes the
 * album keys the next page reads (and refuses link guests outright).
 *
 * Used by UploadBannerComponent.goToAlbum(). Holds nothing, so nothing is lost
 * if a person somehow lands here; the next navigation takes them on.
 */
@Component({
  selector: 'app-album-switch',
  standalone: true,
  template: '',
})
export class AlbumSwitchComponent { }
